import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { useUserAuthentication } from '@ohif/ui-next';

export const PrivateRoute = ({ children, handleUnauthenticated }) => {
  // const [{ user, enabled }] = useUserAuthentication();

  // if (enabled && !user) {
  //   return handleUnauthenticated();
  // }
  const isAuthenticated = () => {
    return !!sessionStorage.getItem('user');
  };
  if (!isAuthenticated()) {
    return <Navigate to="/" />;
  }
  return children;
};

export default PrivateRoute;
